class MFRWCAGOffCanvas {
  constructor(i, e) {
    this.$index = i
    this.$element = $(e)

    this.selectors = {
      offcanvasWrapper: ".offcanvas-content-wrapper",
      offcanvasTrigger: `[data-open="${this.$element.get(0).id}"]`,
      offcanvasCloseTrigger: ".close-button",
    }

    this.$lastFocusedElement = this.$element

    this.init()
  }

  init() {
    this.$focusableElements = this.$element.find('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])')

    this.__handleParentElementStates()
    this.__handleParentElementMutation() 
    this.__handleOffcanvasOpenEvent()
    this.__handleOffcanvasCloseEvent()
  }

  __handleParentElementStates() {
    if (this.$element.attr('aria-hidden') === 'true') {
      this.$focusableElements.each(function() {
        $(this).attr('tabindex', '-1')
      })
    } else {
      this.$focusableElements.each(function() {
        $(this).removeAttr('tabindex')
      })
    }
  }

  __handleParentElementMutation() {
    const observer = new MutationObserver(this.__handleParentElementStates.bind(this))
    observer.observe(this.$element.get(0), { attributes: true, attributeFilter: ['aria-hidden'] })
  }

  __handleOffcanvasOpenEvent() {
    this.$element.on("openedEnd.zf.offCanvas", () => {
      this.$lastFocusedElement = document.querySelector(this.selectors.offcanvasTrigger)
      
      const container = document.getElementById(this.$element.get(0).id).querySelector(this.selectors.offcanvasWrapper)
      const elementToFocus = document.getElementById(this.$element.get(0).id).querySelector(this.selectors.offcanvasCloseTrigger)

      trapFocus(container, elementToFocus)
    })
  }

  __handleOffcanvasCloseEvent() {
    this.$element.on("closed.zf.offCanvas", () => {
      this.$lastFocusedElement.focus()
      removeTrapFocus()
    })
  }
}